@if (isActive()) {
    <div class="impersonation-banner" [class.impersonation-banner--write]="isWriteMode()">
        <div class="impersonation-banner__left">
            <span class="impersonation-banner__text">
                Impersonating <strong>{{ email() }}</strong> · NextPass Business
            </span>
            <span class="impersonation-banner__badge" [class.impersonation-banner__badge--write]="isWriteMode()">
                {{ isWriteMode() ? 'FULL ACCESS' : 'READ-ONLY ACCESS' }}
            </span>
        </div>
        <div class="impersonation-banner__right">
            <span class="impersonation-banner__timer">{{ remainingTime() }}</span>
            <button class="impersonation-banner__btn" type="button" (click)="endSession()">End session</button>
        </div>
    </div>
}
